import React, { memo } from 'react';

const FooterUserStaff = () => {
    return (
        <a
            href='https://docs.vmass.vn/quan-ly/nhan-vien'
            target='_blank'
            className='mb-0 pl-2'
        >
            Hướng dẫn
        </a>
    );
};

export default memo(FooterUserStaff);
